import "./Contact.css";


function Contact() {
  const whatsappPhone = "919840524873";
  const whatsappMessage =
    "Hello Sarrathi Constructions, I would like to know more about your construction services.";

  const openWhatsApp = () => {
    const whatsappUrl = `https://wa.me/${whatsappPhone}?text=${encodeURIComponent(
      whatsappMessage
    )}`;

    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="contact-page" id="contact">
      <div className="contact-hero">
        <p className="section-eyebrow">Contact us</p>

        <h1>Let’s build something meaningful together.</h1>

        <p>
          Whether you are planning a new home, commercial building, renovation,
          or interior work, our team is ready to guide you.
        </p>

        <button
          type="button"
          className="contact-whatsapp-main"
          onClick={openWhatsApp}
        >
          Chat with us on WhatsApp →
        </button>
      </div>

      <div className="contact-right">
        <div className="contact-cards">
          <article className="contact-item">
            <div className="contact-icon">☎</div>

            <div className="contact-details">
              <span className="contact-label">Call us</span>

              <a href="tel:+919840524873">+91 98405 24873</a>

              <a className="secondary-contact" href="tel:+919840798059">
                +91 98407 98059
              </a>
            </div>
          </article>

          <article className="contact-item">
            <div className="contact-icon">✉</div>

            <div className="contact-details">
              <span className="contact-label">Email us</span>

              <a href="mailto:build@sarrathiconstructions.com">
                build@sarrathiconstructions.com
              </a>

              <p>We will get back to you soon.</p>
            </div>
          </article>

          <article className="contact-item contact-address-card">
            <div className="contact-icon">⌖</div>

            <div className="contact-details">
              <span className="contact-label">Visit our office</span>

              <strong>Sarrathi Constructions</strong>

              <p>
                82, Jagannathan Salai, Anjugam Nagar,
                <br />
                SRP Colony, Kolathur, Chennai - 600082.
              </p>

              <a
                className="map-link"
                href="https://www.google.com/maps/search/?api=1&query=Sarrathi+Constructions+82+Jagannathan+Salai+Anjugam+Nagar+SRP+Colony+Kolathur+Chennai"
                target="_blank"
                rel="noreferrer"
              >
                Open in Google Maps →
              </a>
            </div>
          </article>
        </div>

        <div className="contact-map-card">
          <iframe
            title="Sarrathi Constructions location"
            src="https://www.google.com/maps?q=Sarrathi%20Constructions%2C%2082%20Jagannathan%20Salai%2C%20Anjugam%20Nagar%2C%20SRP%20Colony%2C%20Kolathur%2C%20Chennai&output=embed"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>

    
    </section>
  );
}

export default Contact;